/* eslint-disable @mizdra/layout-shift/require-size-attributes */
import React from 'react';
import { StyledLogo } from './styles';

const PartnerLogo = ({ image, name }) => {
  if (!image) return null;

  return <StyledLogo src={image} alt={name} />;
};

export default PartnerLogo;
